import { IconBus, IconCar, IconQuestionMark, IconShip, IconTrain } from '@tabler/icons-react'
import type { LogTransport } from '@mdev/common'

export const TRANSPORT_COLOR: Record<LogTransport, string> = {
  taxi: '#FCD34D',
  bus: '#60A5FA',
  underground: '#F87171',
  ferry: '#67E8F9',
  black: '#E5E7EB',
}

export const TRANSPORT_LABEL: Record<LogTransport, string> = {
  taxi: 'Taxi',
  bus: 'Bus',
  underground: 'Underground',
  ferry: 'Ferry',
  black: 'Black ticket',
}

interface Props {
  transport: LogTransport
  size?: number
  stroke?: number
  color?: string
}

export function TransportIcon( { transport, size = 20, stroke = 2, color }: Props ) {
  const c = color ?? TRANSPORT_COLOR[ transport ]
  switch ( transport ) {
    case 'taxi':
      return <IconCar size={ size } stroke={ stroke } color={ c } />
    case 'bus':
      return <IconBus size={ size } stroke={ stroke } color={ c } />
    case 'underground':
      return <IconTrain size={ size } stroke={ stroke } color={ c } />
    case 'ferry':
      return <IconShip size={ size } stroke={ stroke } color={ c } />
    case 'black':
      return <IconQuestionMark size={ size } stroke={ stroke } color={ c } />
  }
}
